import { useSuspenseQuery } from '@tanstack/react-query';
import { apiClient } from 'lib/api';
import type { QueryConfig } from 'lib/react-query';
import type { RedditKeyword, RedditKeywordsResponse } from '../types';
import queryKeys from './queryKeys';

export const getRedditKeywords = async (signal?: AbortSignal): Promise<RedditKeyword[]> => {
  const res = await apiClient.get<RedditKeywordsResponse>(`/reddit/keywords`, { signal });
  return res.data.data;
};

interface UseRedditKeywordsOptions<TData> {
  config?: QueryConfig<typeof getRedditKeywords, TData>;
}

export const useRedditKeywords = <TData = RedditKeyword[]>({ config }: UseRedditKeywordsOptions<TData> = {}) => {
  return useSuspenseQuery({
    staleTime: 60 * 60 * 1000,
    ...config,
    queryFn: ({ signal }) => getRedditKeywords(signal),
    queryKey: queryKeys().keywords(),
  });
};
